import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Partners_logo.css";

import partner1 from "../assets/Partners/Partners-2.svg";
import partner2 from "../assets/Partners/Partners-1.svg";
import partner3 from "../assets/Partners/Partners-8.svg";
import partner4 from "../assets/Partners/Partners-3.svg";
import partner5 from "../assets/Partners/sble.png";
import partner6 from "../assets/Partners/Partners-4.svg";
import partner7 from "../assets/Partners/Partners-6.svg";
import partner8 from "../assets/Partners/Partners-5.svg";
import partner9 from "../assets/Partners/berger.png";
import partner10 from "../assets/Partners/leinos.png";
import partner11 from "../assets/Partners/Partners-9.svg";
import partner12 from "../assets/Partners/Partners-12.svg";

const Partners = () => {
  return (
    <section className="partners-section">
      <div className="partners-container">
        <span className="partners-label">OUR PARTNERS</span>
        <h2 className="partners-title">
          Building Strong <br />
          Partnerships
        </h2>

        <Swiper
  modules={[Autoplay, Pagination]}
  spaceBetween={20}
  slidesPerView={1}   // default (mobile first)
  loop={true}
  autoplay={{ delay: 4000, disableOnInteraction: false }}
  pagination={{
    clickable: true,
    el: ".custom-swiper-pagination1",
  }}
  breakpoints={{
    481: { slidesPerView: 2 },   // tablets
    769: { slidesPerView: 3 },   // small desktops
    1025: { slidesPerView: 4 },  // large desktops
  }}
  className="partners-slider"
>

          <SwiperSlide><div className="partner-card"><img src={partner1} alt="MKS Atotech" /></div></SwiperSlide>
          <SwiperSlide><div className="partner-card"><img src={partner2} alt="Norton" /></div></SwiperSlide>
          <SwiperSlide><div className="partner-card"><img src={partner3} alt="Seco" /></div></SwiperSlide>
          <SwiperSlide><div className="partner-card"><img src={partner4} alt="Sisecam" /></div></SwiperSlide>
          <SwiperSlide><div className="partner-card"><img src={partner5} alt="Kulzer" /></div></SwiperSlide>
          <SwiperSlide><div className="partner-card"><img src={partner6} alt="Dormer Pramet" /></div></SwiperSlide>
          <SwiperSlide><div className="partner-card"><img src={partner7} alt="Dormer Pramet" /></div></SwiperSlide>
          <SwiperSlide><div className="partner-card"><img src={partner8} alt="Dormer Pramet" /></div></SwiperSlide>
          <SwiperSlide><div className="partner-card"><img src={partner9} alt="Dormer Pramet" /></div></SwiperSlide>
          <SwiperSlide><div className="partner-card"><img src={partner10} alt="Dormer Pramet" /></div></SwiperSlide>
          <SwiperSlide><div className="partner-card"><img src={partner11} alt="Dormer Pramet" /></div></SwiperSlide>
          <SwiperSlide><div className="partner-card"><img src={partner12} alt="Dormer Pramet" /></div></SwiperSlide>
        </Swiper>

        {/* Custom pagination */}
        <div className="custom-swiper-pagination1" style={{ marginTop: "40px", textAlign: "center" }}></div>
        <style>
  {`
    /* Base dot */
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #ccc;
      opacity: 1;
      border-radius: 50%;
      position: relative;
    }

    /* Active dot */
    .swiper-pagination-bullet-active {
      background: #CA7511 !important;
    }

    /* Outer ring */
    .swiper-pagination-bullet-active::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 14px;   /* outer ring size */
      height: 14px;
      border: 1px solid #CA7511;
      border-radius: 50%;
    }
  `}
</style>

        <div className="partners-cta">
          <a href="/partners" className="partners-btn">Explore Now</a>
        </div>
      </div>
    </section>
  );
};

export default Partners;
